import { getCurrentUserId } from '../../publicSession/selectors';
export function canUserVoteInPoll(state, _a) {
    var poll = _a.poll;
    if (!poll || poll.hasVoted) {
        return false;
    }
    // we don't allow the poll owner to vote
    var currentUserId = getCurrentUserId(state);
    if (currentUserId === poll.user.userId) {
        return false;
    }
    return true;
}
//# sourceMappingURL=selectors.js.map